import { useState,useEffect } from "react";
import AxiosFetchData from "../pages/AxiosFetchData";
import { useNavigate, useParams } from 'react-router-dom';
import ConfirmationButton from '../components/ConfirmationButton';
import { CatchWrapperSync, CatchWrapperAsync } from "../utils/catchwrapper";
import Bindcomponent from "../utils/bindcomponent";
export const useStatusHookList = () =>{
      const Navigate = useNavigate();
      const [name, setName] = useState('');
      const [confirmStatusOpen, setConfirmStatusOpen] = useState('');
      const [confirmDeleteOpen, setConfirmDeleteOpen] = useState('');
      const [rows, setRows] = useState([]);
      const [idStatus, setIdStatus] = useState('');
      const [message, setmessage] = useState('');
      const [roleAccess, setRoleAccess] = useState('');
      const [tipe, setTipe] = useState('');
      const [role, setRole] = useState('');
 //const [showLoader, setShowLoader] =  useState(false);
    useEffect(() => {
        fetchData()
    },[])
    
    const fetchData = async () => {
        CatchWrapperAsync(async () => {
            const response = await AxiosFetchData.get(`GetStatus`).refreshToken(Navigate,"status",true);
            if(response){
              setRows(response.data); 
              setRoleAccess(response.roleaccess)
              setRole(response.decode.role)
          }
        
        },setmessage,setTipe)
    };

      const columns = [
        { field: 'rowNumber', headerName: 'No.', width: 80 },
        { field: 'name', headerName: 'Name', width: 150 },
        {
          field: 'actions',
          headerName: 'Actions',
          width: 150,
          renderCell: (params) => (
            <>
            {role.toUpperCase() == "SUPERADMIN".toUpperCase() && (
                <button
                onClick={() => handleEdit(params.row)} // Pass the project ID to the edit function
                className="btn btn-primary mr-2"
                disabled={!roleAccess.UPDATE}
              >
                Edit
              </button>
              ) 
              }
               
              {params.row.id !=3 && role.toUpperCase() == "SUPERADMIN".toUpperCase() && (
                <Bindcomponent component='ConfirmationButton' classname='btn btn-danger' text="Do you want delete this data?" type="button" onClick={() => handleDeleteStatus(params.row.id)} disabled={!roleAccess.DELETE}>Delete</Bindcomponent>
               )}
      
            </>
            
          ),
        },
     ];

      const handleEdit = (data) => {
        CatchWrapperSync(() => {
            setIdStatus(data.id)
            setName(data.name)
            setConfirmStatusOpen(true)
        }, setmessage, setTipe)
        
       
      };

      const handleDeleteStatus = async (data) => {
        CatchWrapperAsync(async () => {
            const response = await AxiosFetchData.delete(`DeleteStatus/${data}`).refreshToken(Navigate,"status");
            if(response){
                setRows((prevRows) => prevRows.filter((row) => row.id !== data));
            }
            setmessage(response.data)
        },setmessage,setTipe)
        
    };

    async function AddStatus(e){
      e.preventDefault(); 
    
      CatchWrapperAsync(async ()=>{
        if(idStatus){
            var data = {
              id: idStatus,
              name : name
            }
            var response = await AxiosFetchData.post(`UpdateStatus`, data).refreshToken(Navigate,"status")
            if(response){
              setConfirmStatusOpen(false);
            }
          
            setmessage(response.data)
        }else{
            var data = {
              name : name
            }
      
            var response = await AxiosFetchData.post(`AddStatus`, data).refreshToken(Navigate,"status")
      
            if(response){
              setConfirmStatusOpen(false);
            }
          
            setmessage(response.data)
        }
          
        await fetchData();
      },setmessage,setTipe)
    }

    function AddProjectData() {
        setIdStatus(null)
        setName('');
        setConfirmStatusOpen(true);
    }

      return {setName, setConfirmStatusOpen, setConfirmDeleteOpen,  setmessage, setTipe, rows, columns, AddStatus,message,tipe,roleAccess ,confirmStatusOpen,name,idStatus,confirmDeleteOpen,handleDeleteStatus,AddProjectData,role}
}